import MessageParser from '../Chatbot/MessageParser'
import ActionProvider from '../Chatbot/ActionProvider'

export class MessageHandler {
  constructor(sendMessage, setComponent) {
    this.sendMessage = sendMessage
    this.setComponent = setComponent
    this.messageParser = MessageParser
    this.actionProvider = ActionProvider
  }

  handle(userMessage) {
    const actionProvider = new ActionProvider(this.sendMessage, this.setComponent)
    const messageParser = new MessageParser(userMessage, actionProvider)
    messageParser.parseMessage()
  }
}